import { isEmpty } from "lodash";
import { AboutYou1FormData, InsuranceFormData } from "features/checkIn/types";
import { isValidDateOfBirth } from "utils/dateOfBirthValidation";
import { isValidZip } from "utils/zipValidation";

const hasValidSubscriberName = (value?: string) =>
  !!value && /^[A-Za-z -]+$/.test(value);

export const hasRequiredAboutYouFields = (
  aboutYouData?: Partial<AboutYou1FormData> | null
) =>
  !!(
    aboutYouData?.address1 &&
    aboutYouData?.city &&
    aboutYouData?.state &&
    aboutYouData?.zipCode &&
    isValidZip(aboutYouData.zipCode) === true &&
    aboutYouData?.gender
  );

export const hasRequiredInsuranceAddressFields = (
  insurance: Partial<InsuranceFormData>
) => {
  if (insurance.isPrimaryPolicyHolder !== "no") {
    return true;
  }

  return !!(
    insurance.address1 &&
    insurance.state &&
    insurance.city &&
    insurance.zipCode &&
    insurance.subscriberBirthSex
  );
};

export const hasValidInsuranceForm = (insurance?: Partial<InsuranceFormData>) =>
  !!(
    insurance &&
    insurance.insuranceCarrier &&
    insurance.isPrimaryPolicyHolder &&
    hasValidSubscriberName(insurance.subscriberFirstName) &&
    hasValidSubscriberName(insurance.subscriberLastName) &&
    insurance.subscriberId &&
    insurance.subscriberDateOfBirth &&
    isValidDateOfBirth(insurance.subscriberDateOfBirth) === true &&
    hasRequiredInsuranceAddressFields(insurance) &&
    (insurance.insuranceCarrier !== "VSP" || insurance.subscriberSsn) &&
    (insurance.isPrimaryPolicyHolder === "yes" || insurance.relationToPatient) &&
    (insurance.insuranceCarrier !== "Other Insurance" ||
      insurance.otherInsuranceName)
  );

export const hasValidInsuranceSelection = (
  insuranceForms: Array<Partial<InsuranceFormData>>
) => {
  let foundInsurance = false;

  for (const insurance of insuranceForms) {
    if (!isEmpty(insurance)) {
      foundInsurance = true;
      if (!hasValidInsuranceForm(insurance)) {
        return false;
      }
    }
  }

  return foundInsurance;
};

export const canSubmitAppointmentSuccess = ({
  aboutYouData,
  insuranceForms,
  skipInsurance,
}: {
  aboutYouData?: Partial<AboutYou1FormData> | null;
  insuranceForms: Array<Partial<InsuranceFormData>>;
  skipInsurance: boolean;
}) =>
  hasRequiredAboutYouFields(aboutYouData) &&
  (skipInsurance || hasValidInsuranceSelection(insuranceForms));
